/* ==========================================================================
   FreezeCap™ — fc-faq.liquid wiring (extracted from inline script in v6.28)
   --------------------------------------------------------------------------
   Accordion behaviour for the homepage FAQ section. Each FAQ list root
   is identified by `[data-fc-faq-list]`; the script scopes its DOM lookups
   per root, so cloning the section in the theme editor still works.
   ========================================================================== */
(function () {
  function wire(list) {
    var items = list.querySelectorAll('.faq-item');

    items.forEach(function (item) {
      var btn    = item.querySelector('.faq-q');
      var answer = item.querySelector('.faq-a');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = item.classList.contains('open');
        /* Close all siblings */
        items.forEach(function (i) {
          i.classList.remove('open');
          var siblingBtn = i.querySelector('.faq-q');
          if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
        });
        /* Open clicked if it was closed */
        if (!isOpen) {
          item.classList.add('open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-fc-faq-list]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
